import { Component, OnInit, OnDestroy } from '@angular/core';
import { sweetAlert } from '../../../utils/swal';
import { StaffService } from '../staff-service/staff.service';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
@Component({
  selector: 'app-staff-main',
  templateUrl: './staff-main.component.html',
  styleUrls: ['./staff-main.component.css']
})
export class StaffMainComponent implements OnInit, OnDestroy {
  staffList = [];
  search;
  imageModalUrl;
  status = "active";

  constructor(
    private staffService: StaffService) {
  }

  ngOnInit() {
    this.getStaffList();
  }

  getStaffList() {
    this.staffService
      .getStaffList()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if(data) {
          this.staffList = data;
        }
    }, err => {
      sweetAlert('Error', err, 'warning', 'OK');
    });
  }

  openImageModal(url) {
    this.imageModalUrl = url;
  }

  
ngOnDestroy(): void {
}
}
